// IKAIKA: the theme's free-shipping-bar snippet only gets initialized (message
// text, progress width, --loaded class) by the cart drawer's own JS controller.
// A copy placed elsewhere on the page (eg. the product page) never gets filled
// in. This initializes any free-shipping-bar found outside the cart drawer
// directly from its own data attributes, using the real cart total at page load.
(function () {
  function formatUSD(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function initBar(bar) {
    var thresholdCents = parseFloat(bar.dataset.threshold) * 100;
    var cartTotalCents = parseFloat(bar.dataset.cartTotal);
    if (isNaN(thresholdCents) || isNaN(cartTotalCents)) return;

    var remainingCents = thresholdCents - cartTotalCents;
    var messageEl = bar.querySelector('.free-shipping-bar__message');
    var progressEl = bar.querySelector('.free-shipping-bar__bar-progress');
    var progressPct = Math.max(0, Math.min(100, (cartTotalCents / thresholdCents) * 100));

    var message;
    if (remainingCents <= 0) {
      message = bar.dataset.freeShippingSuccessMessage;
    } else {
      message = bar.dataset.freeShippingPendingMessage.replace(
        '{{ remaining_amount }}',
        formatUSD(remainingCents)
      );
    }

    if (messageEl) messageEl.textContent = message;
    if (progressEl) progressEl.style.width = progressPct + '%';
    bar.classList.add('free-shipping-bar--loaded');
  }

  function init() {
    document.querySelectorAll('.free-shipping-bar').forEach(function (bar) {
      if (bar.classList.contains('free-shipping-bar--loaded')) return;
      if (bar.closest('.quick-cart')) return;
      initBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
